var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"background white--text text-center w-100 fill-height d-flex align-center justify-center flex-nowrap"},[_c('div',{staticStyle:{"width":"10rem"}},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"white"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }